<template>
    <adminTable
      :tableLoading="tableLoading"
      :totalList="totalList"
      v-model:page="page"
      v-model:limit="limit"
      v-model:searchForm="searchForm"
      :tableData="tableData"
      @search="getList"
    >
      <template v-slot:form-inline-items>
        <el-form-item>
          <el-input
            v-model="searchForm.username"
            placeholder="请输入用户名"
            clearable
          />
        </el-form-item>
        <el-form-item>
          <el-input
            v-model="searchForm.phone"
            placeholder="请输入手机号码"
            clearable
          />
        </el-form-item>
        <el-form-item>
          <el-select
            v-model="searchForm.is_test"
            placeholder="请选择账号类型"
            clearable
          >
            <el-option
              v-for="item in accountTypeEnums"
              :key="item.value"
              :label="item.label"
              :value="item.value"
            />
          </el-select>
        </el-form-item>
        <el-form-item>
          <el-date-picker
            v-model="searchForm.starttime"
            type="datetime"
            placeholder="开始时间"
            format="YYYY-MM-DD HH:mm:ss"
            value-format="YYYY-MM-DD HH:mm:ss"
          />
        </el-form-item>
        <el-form-item>
          <el-date-picker
            v-model="searchForm.endtime"
            type="datetime"
            placeholder="结束时间"
            format="YYYY-MM-DD HH:mm:ss"
            value-format="YYYY-MM-DD HH:mm:ss"
          />
        </el-form-item>
      </template>
      <template v-slot:table>
        <el-table-column prop="id" label="ID" width="60">
          <template #default="scope">
            <span :style="{ color: scope.row.is_test == 1 ? 'red' : '' }">
              {{ scope.row.id }}
            </span>
          </template>
        </el-table-column>
        <el-table-column prop="uid" label="用户ID" width="130">
          <template #default="scope">
            <span :style="{ color: scope.row.is_test == 1 ? 'red' : '' }">
              {{ scope.row.uid }}
            </span>
          </template>
        </el-table-column>
        <el-table-column prop="username" label="用户名" width="130">
          <template #default="scope">
            <span :style="{ color: scope.row.is_test == 1 ? 'red' : '' }">
              {{ scope.row.username }}
            </span>
          </template>
        </el-table-column>
        <el-table-column prop="phone" label="手机号" width="130">
          <template #default="scope">
            <span :style="{ color: scope.row.is_test == 1 ? 'red' : '' }">
              {{ scope.row.phone }}
            </span>
          </template>
        </el-table-column>
        <el-table-column prop="is_test" label="账号类型" width="130">
          <template #default="scope">
            <span :style="{ color: scope.row.is_test == 1 ? 'red' : '' }">
              {{ getLabelByVal(scope.row.is_test, accountTypeEnums) }}
            </span>
          </template>
        </el-table-column>
      <el-table-column prop="img" label="图片" width="200">
          <template #default="scope">
            {{ scope.row.img ? "" : "--" }}
            <el-image
              v-if="scope.row.img"
              class="previewImg"
              :preview-teleported="true"
              :src="proxy.IMG_BASE_URL + scope.row.img"
              :zoom-rate="1.2"
              :max-scale="7"
              :min-scale="0.2"
              :preview-src-list="[proxy.IMG_BASE_URL + scope.row.img]"
              show-progress
              :initial-index="0"
              fit="cover"
            />
          </template>
        </el-table-column>
        <el-table-column prop="amount" label="金额" width="130">
          <template #default="scope">
            <span :style="{ color: scope.row.is_test == 1 ? 'red' : '' }">
              {{ scope.row.amount }}
            </span>
          </template>
        </el-table-column>
        <el-table-column prop="raffle_id" label="抽奖ID" width="130">
          <template #default="scope">
            <span :style="{ color: scope.row.is_test == 1 ? 'red' : '' }">
              {{ scope.row.raffle_id }}
            </span>
          </template>
        </el-table-column>
        <el-table-column prop="raffle_name" label="抽奖产品" width="130">
          <template #default="scope">
            <span :style="{ color: scope.row.is_test == 1 ? 'red' : '' }">
              {{ scope.row.raffle_name }}
            </span>
          </template>
        </el-table-column>
        <el-table-column prop="desc" label="描述" width="200">
          <template #default="scope">
            <span :style="{ color: scope.row.is_test == 1 ? 'red' : '' }">
              {{ scope.row.desc }}
            </span>
          </template>
        </el-table-column>
        <el-table-column prop="create_at" label="创建时间" width="130">
          <template #default="scope">
            <span :style="{ color: scope.row.is_test == 1 ? 'red' : '' }">
              {{ scope.row.create_at }}
            </span>
          </template>
        </el-table-column>
        <el-table-column prop="update_at" label="更新时间" width="130">
          <template #default="scope">
            <span :style="{ color: scope.row.is_test == 1 ? 'red' : '' }">
              {{ scope.row.update_at }}
            </span>
          </template>
        </el-table-column>
        
        <el-table-column
          label="操作"
          fixed="right"
          width="200"
          v-if="currentUser.role == 0"
        >
          <template #default="scope">
           
            <el-button
              type="danger"
              icon="Delete"
              v-permission
              @click="deleteAction(scope.row)"
              >删除</el-button
            >
          </template>
        </el-table-column>
      </template>
      
    </adminTable>
  </template>
  
  <script setup>
  import { ref, getCurrentInstance, onMounted, reactive } from "vue";
  import { ElMessage, ElMessageBox } from "element-plus";
  import { accountTypeEnums, getLabelByVal } from "../../config/enums";
  
  const dialogFlag = ref(false);
  const editFormRef = ref(false);
  const editRow = ref({});
  const formType = ref("add");
  const searchForm = reactive({
    username: '',
    phone: '',
    is_test: '',
    starttime: '',
    endtime: ''
  })
  
  onMounted(() => {
    getList();
  });
  
  const currentUser = JSON.parse(sessionStorage.getItem("currentUser"));
  const { proxy } = getCurrentInstance();
  
  const page = ref(1);
  const limit = ref(10);
  const totalList = ref(0);
  const tableLoading = ref(false);
  const tableData = ref([]);
  const getList = async () => {
    tableLoading.value = true;
    const res = await proxy.$http({
      type: "get",
      url: "/RaffleBig/getRaffleLogLists",
      params: {
        ...searchForm,
        page: page.value,
        limit: limit.value,
      },
    });
    tableLoading.value = false;
    if (res.code == 0) {
      tableData.value = res.data.data;
      totalList.value = res.data.total;
    }
  };
  
  const editItem = (type, row) => {
    formType.value = type;
    editRow.value = row;
    dialogFlag.value = true;
  };
  
  const deleteAction = (row) => {
    ElMessageBox.confirm("是否删除?", "Warning", {
      confirmButtonText: "确认",
      cancelButtonText: "取消",
      type: "warning",
    })
      .then(async () => {
        const res = await proxy.$http({
          method: "get",
          url: "/RaffleBig/deleteRaffleLogLists?id=" + row.id,
        });
        if (res.code == 0) {
          getList();
        }
        ElMessage({
          type: "success",
          message: res.msg,
        });
      })
      .catch(() => {
        ElMessage({
          type: "info",
          message: "取消删除",
        });
      });
  };
  
  </script>
  
  <style lang="less" scoped></style>
  